/**
 * SyncedLyrics — 歌詞面板（**純閱讀；用戶自己捲**）
 *
 * ⚠️ **2026-10-11 產品負責人**：原本做「跟唱同步」，但實測**對唔到拍** ——
 *   根因係 **provider（Mureka）冇回任何時間碼**（設計 **R-02**）→ 任何估算都唔會準。
 *   產品負責人指示：「**just keep the 歌詞 no need to move, but allow to scroll by user**」
 *   → 所以：**取消自動捲動**、**取消現行行高亮**；只留一個**可以自己捲**嘅歌詞面板。
 *
 * ⚠️ 要「真同步」＝ 要 provider 時間碼 或 ASR 對齊（記喺 `P-282`）。
 * ⚠️ 冇歌詞 → 照實講（`player_no_lyrics`）。
 */
import { useTranslation } from 'react-i18next';

export interface SyncedLyricsProps {
  lyrics: string | null;
}

export default function SyncedLyrics({ lyrics }: SyncedLyricsProps) {
  const { t } = useTranslation();
  const lines = (lyrics ?? '')
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);

  if (!lines.length) {
    return (
      <div className="player__lyrics" data-testid="player-lyrics">
        <p className="page__hint">{t('player_no_lyrics')}</p>
      </div>
    );
  }

  return (
    <div className="player__lyrics" data-testid="player-lyrics">
      {lines.map((l, i) => (
        <p key={i} className="lyric">
          {l}
        </p>
      ))}
    </div>
  );
}
